var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import fornecService from "@/core/services/fornecService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Limites_ReembolsoActions } from "@/store/enums/FornecEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Limites_ReembolsoModule = class Limites_ReembolsoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Limites_ReembolsoActions.POST_LIMITES_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.post("Limites_Reembolso/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Limites_ReembolsoActions.PUT_LIMITES_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.put("Limites_Reembolso/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Limites_ReembolsoActions.DELETE_LIMITES_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.delete("Limites_Reembolso/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Limites_ReembolsoActions.DELETE_RANGE_LIMITES_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.delete("Limites_Reembolso/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Limites_ReembolsoActions.FILTER_LIMITES_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.post("Limites_Reembolso/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Limites_ReembolsoActions.GET_LIMITES_REEMBOLSO]() {
        return new Promise(resolve => {
            fornecService.get("Limites_Reembolso/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Limites_ReembolsoActions.GETWITHDISABLED_LIMITES_REEMBOLSO]() {
        return new Promise(resolve => {
            fornecService.get("Limites_Reembolso/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Limites_ReembolsoActions.GET_BY_ID_LIMITES_REEMBOLSO](data) {
        return new Promise(resolve => {
            fornecService.get("Limites_Reembolso/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Limites_ReembolsoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Limites_ReembolsoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Limites_ReembolsoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Limites_ReembolsoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Limites_ReembolsoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Limites_ReembolsoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Limites_ReembolsoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Limites_ReembolsoModule.prototype, _h, null);
Limites_ReembolsoModule = __decorate([
    Module
], Limites_ReembolsoModule);
export default Limites_ReembolsoModule;
//# sourceMappingURL=Limites_ReembolsoModule.js.map